import { create } from "zustand";
import { SortType } from "@/types/referals";

interface SortTypeDashboardState {
  sortType: SortType;
  setSortType: (elem: SortType) => void;
}

export const SORT_TYPE_DASHBOARD_PARAMS: Record<SortType, string> = {
  max: "amount_desc",
  min: "amount_asc",
  new: "newest",
  old: "oldest",
};

export const DEFAULT_SORT_TYPE: SortType = "old";
export const DEFAULT_SORT_PARAM = SORT_TYPE_DASHBOARD_PARAMS[DEFAULT_SORT_TYPE];

export const useSortTypeDashboardStore = create<SortTypeDashboardState>()(
  (set) => ({
    sortType: DEFAULT_SORT_TYPE,
    setSortType: (elem) =>
      set(() => ({
        sortType: elem,
      })),
  })
);
